import type { KioskStateAction } from '../../../../../components/kiosk-state-panel'
import {
  KioskCardReaderPanel,
  type KioskCardReaderView,
} from '../identification/KioskCardReaderPanel'

const SCHEDULER_CARD_TEST_IDS = {
  panel: 'scheduler-card-panel',
  readCard: 'scheduler-read-card',
  retry: 'scheduler-card-retry',
  readError: 'scheduler-card-read-error',
} as const

/**
 * Renders the card-reader mode for scheduler patient identification with the
 * shared kiosk card panel and the scheduler's stable test ids.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * type SchedulerCardModePanelProps = Parameters<typeof SchedulerCardModePanel>[0]
 * ```
 */
export function SchedulerCardModePanel({
  cardReader,
  searchAction,
}: {
  cardReader: KioskCardReaderView
  /** "Mit Namen suchen" from any card state (KO-73). */
  searchAction?: KioskStateAction
}) {
  return (
    <KioskCardReaderPanel
      cardReader={cardReader}
      testIds={SCHEDULER_CARD_TEST_IDS}
      searchAction={searchAction}
    />
  )
}
